var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 94,
    viewBox: "0 0 57 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.251 26.562C56.251 39.699 46.095 50.609 32.813 52.726V89.062C32.813 91.6518 30.7153 93.7495 28.1255 93.7495C25.5357 93.7495 23.438 91.6518 23.438 89.062V52.726C10.157 50.6088 0 39.699 0 26.562C0 11.914 12.617 0 28.125 0C43.633 0 56.251 11.914 56.251 26.562Z",
    fill: "#E67E22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/inProgress.e54613db2fd68929f00b2138ff883967.svg";
export { ForwardRef as ReactComponent };